module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/inputs/spk-text/spk-text.component.scss
// module id = ./src/app/components/framework/spk/inputs/spk-text/spk-text.component.scss
// module chunks = main